import { memo } from 'react';
import { jsx } from 'react/jsx-runtime';

function ImgQrLoading(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  return /*#__PURE__*/jsx("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      opacity: "0.1",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M33.5769 48.7102H48.4732V0H32.8671V26.0702L14.8962 0H0V48.7102H15.6061V22.64L33.5769 48.7102ZM73.6452 36.3549V12.1183H97.8817V36.3549H73.6452ZM61.5269 3.02957C61.5269 1.35639 62.8833 0 64.5564 0H106.97C108.644 0 110 1.35639 110 3.02957V45.4436C110 47.1168 108.644 48.4731 106.97 48.4731H64.5564C62.8833 48.4731 61.5269 47.1168 61.5269 45.4436V3.02957ZM12.1183 73.6444V97.881H36.3549V73.6444H12.1183ZM3.02957 61.5261C1.35639 61.5261 0 62.8825 0 64.5557V106.97C0 108.643 1.35639 109.999 3.02957 109.999H45.4436C47.1168 109.999 48.4732 108.643 48.4732 106.97V64.5557C48.4732 62.8825 47.1168 61.5261 45.4436 61.5261H3.02957ZM97.8817 85.7627H110V64.5557C110 62.8825 108.644 61.5261 106.97 61.5261H97.8817V85.7627ZM97.8817 97.881V85.7627H85.7635V73.6444H73.6452V61.5261H64.5564C62.8833 61.5261 61.5269 62.8825 61.5269 64.5557V73.6444H73.6452V85.7627H61.5269V106.97C61.5269 108.643 62.8833 109.999 64.5564 109.999H85.7635V97.881H97.8817ZM97.8817 97.881V109.999H106.97C108.644 109.999 110 108.643 110 106.97V97.881H97.8817ZM85.7635 97.881H73.6452V85.7627H85.7635V97.881Z",
      fill: "black"
    })
  });
}
var ImgQrLoading$1 = /*#__PURE__*/memo(ImgQrLoading);

export { ImgQrLoading$1 as default };
